import { formatNumber } from '@portals-platform/utils';
import type { Money } from '../../data-access/index.js';

export const EMPTY_VALUE = '—';

const longDate = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
});

export const orEmpty = (value: string | null | undefined): string =>
  value?.trim() ? value : EMPTY_VALUE;

/** An unparseable value is shown as received rather than hidden behind a dash. */
export function formatLongDate(value: string | null | undefined): string {
  if (!value) {
    return EMPTY_VALUE;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : longDate.format(date);
}

export function formatMoney(money: Money | null | undefined): string {
  if (!money) {
    return EMPTY_VALUE;
  }

  return `${money.currency} ${formatNumber(money.amount || 0, { maximumFractionDigits: 2 })}`;
}
